import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import "rxjs/add/operator/catch";
import * as _ from "lodash";

@Injectable()
export class MenuService {
  constructor(private _http: HttpClient) {}

  public getMenu() {
    return this._http
      .get("/api/menu")
      .map((response: Response) => response)
      .catch(this._handleError);
  }

  public getMenuByLocationID(locationID) {
    return this._http
      .get("/api/locations/menu", { params: { locationID: locationID } })
      .map((response: Response) => {
        // Remove BEER
        let menu = _.reject(response, {
          _embedded: {
            menu_categories: [
              {
                name: "BEER"
              }
            ]
          }
        });

        // Remove WINE
        menu = _.reject(menu, {
          _embedded: {
            menu_categories: [
              {
                name: "WINE"
              }
            ]
          }
        });

        // Remove A LA CARTE
        menu = _.reject(response, {
          _embedded: {
            menu_categories: [
              {
                name: "A LA CARTE"
              }
            ]
          }
        });

        // Remove LIQUOR
        menu = _.reject(menu, {
          _embedded: {
            menu_categories: [
              {
                name: "LIQUOR"
              }
            ]
          }
        });

        // Remove Not Available
        return _.reject(menu, {
          _embedded: {
            menu_categories: [
              {
                name: "NOT AVAILABLE"
              }
            ]
          }
        });
      })
      .catch(this._handleError);
  }

  public getMenuLocations() {
    return this._http
      .get("/api/locations")
      .map((response: Response) => response)
      .catch(this._handleError);
  }

  private _handleError(error) {
    console.error(error);
    if (error.status == 404) {
      // alert('Please change all references to /confidential/fixture/work.json to /fixture/work.json in the work.service.ts file');
    }
    return Observable.throw(error.json().error || "Server error");
  }
}



// WEBPACK FOOTER //
// ./src/app/services/menu/menu.service.ts